import { memorize } from "./utils";

export const hasPersianChar = memorize((data: string): boolean => {
  const rules = {
    arabic_alpha: "ةكىيًٍە",
    arabic_num: "٠١٢٣٤٥٦٧٨٩",
    persian_alpha: "ءآأؤإئابتثجحخدذرزسشصضطظعغفقلمنهوَُِّٕپچژکگھی",
    persian_num: "۰۱۲۳۴۵۶۷۸۹",
    punctuation_marks: "،؛؟ـ٪٫٬",
  };
  let rule: keyof typeof rules;
  for (rule in rules) {
    if (data.match(`[${rules[rule]}]`) !== null) return true;
  }
  return false;
});

export const changeDirection = (selector: string): void => {
  setTimeout(() => {
    document.querySelectorAll<HTMLElement>(`${selector}:not([dir])`).forEach((el) => {
      if (el.textContent === "" || hasPersianChar(el.textContent || "")) {
        el.dir = "rtl";
        el.style.marginLeft = "auto";
        el.style.marginRight = "0";
      } else {
        el.dir = "ltr";
        el.style.marginLeft = "0";
        el.style.marginRight = "auto";
      }
    });
  });
};
